import { createAction, props } from '@ngrx/store';
import { Account } from '../../models/account';

export enum AccountsActionTypes {
    searchAccounts = '[Accounts] search accounts',
    searchAccountsSuccess = '[Accounts] search accounts success',
    searchAccountsFailure = '[Accounts] search accounts failure',
    getPaginatedAccounts = '[Accounts] get paginated accounts',
    getPaginatedAccountsSuccess = '[Accounts] get paginated accounts success',
    getPaginatedAccountsFailure = '[Accounts] get paginated accounts failure',
    getAccount = '[Accounts] get account',
    getAccountSuccess = '[Accounts] get account success',
    getAccountFailure = '[Accounts] get account failure',
    updateAccount = '[Accounts] update account',
    updateAccountSuccess = '[Accounts] update account success',
    updateAccountFailure = '[Accounts] update account failure',
    enableAccount = '[Accounts] enable account',
    enableAccountSuccess = '[Accounts] enable account success',
    enableAccountFailure = '[Accounts] enable account failure',
}

export const SearchAccounts = createAction(
    AccountsActionTypes.searchAccounts,
    props<{ limit: number; searchString: string; nftId?: string }>()
);

export const SearchAccountsSuccess = createAction(AccountsActionTypes.searchAccountsSuccess, props<any>());

export const SearchAccountsFailure = createAction(AccountsActionTypes.searchAccountsFailure, props<any>());

export const GetPaginatedAccounts = createAction(
    AccountsActionTypes.getPaginatedAccounts,
    props<{
        searchTerm: string;
        pageSize: number;
        pageNumber: number;
        userType: string;
        fromDate?: string;
        toDate?: string;
    }>()
);

export const GetPaginatedAccountsSuccess = createAction(AccountsActionTypes.getPaginatedAccountsSuccess, props<any>());

export const GetPaginatedAccountsFailure = createAction(AccountsActionTypes.getPaginatedAccountsFailure, props<any>());

export const GetAccount = createAction(AccountsActionTypes.getAccount, props<{ accountId: string }>());

export const GetAccountSuccess = createAction(AccountsActionTypes.getAccountSuccess, props<{ account: Account }>());

export const GetAccountFailure = createAction(AccountsActionTypes.getAccountFailure, props<any>());

export const UpdateAccount = createAction(
    AccountsActionTypes.updateAccount,
    props<{ accountId: string; account: Partial<Account> }>()
);

export const UpdateAccountSuccess = createAction(AccountsActionTypes.updateAccountSuccess, props<{ account: Account }>());

export const UpdateAccountFailure = createAction(AccountsActionTypes.updateAccountFailure, props<any>());

export const EnableAccount = createAction(AccountsActionTypes.enableAccount, props<{ accountId: string }>());

export const EnableAccountSuccess = createAction(AccountsActionTypes.enableAccountSuccess, props<{ account: Account }>());

export const EnableAccountFailure = createAction(AccountsActionTypes.enableAccountFailure, props<any>());

export const RemoveKyc = createAction('[KYC] remove kyc', props<{ userId: string; reason: string }>());
